export default __webpack_public_path__ + "static/media/oddiyana-ventures.0d3e9bb8.jpg";